/**
 * IMPORTANT: Initialize Sentry FIRST before any other imports
 * This ensures error tracking captures everything
 */
import { initSentry } from './services/sentry';
initSentry();

import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
import './styles/theme.css';
import './styles/web-overrides.css';

// Initialize analytics
import { initMixpanel } from './services/analytics';
initMixpanel();

// Extension bridge initialization
import './extension-bridge/extension-listener';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
